import { ModuleConfig } from '@/core/module';
import { essProductManagementRoutes } from './routes';

export const ESSProductManagementModule: ModuleConfig = {
    name: 'ESSProductManagement',
    routes: essProductManagementRoutes,
};
